import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieStateService } from './services/cookie-state.service';
import { ProcessingStateService } from './services/processing-state.service';
import { SessionService } from './services/session.service';
import { FooterComponent } from "./components/layout/footer/footer.component";
import { HeaderComponent, HeaderTheme } from './components/layout/header/header.component';
import { NavigationComponent } from './components/layout/navigation/navigation.component';
import { LoadingComponent } from "./components/loading/loading.component";
import {
  TranslationStatusNotificationsComponent
} from './components/translation-status-notifications/translation-status-notifications.component';

type Theme = HeaderTheme;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    NavigationComponent,
    LoadingComponent,
    TranslationStatusNotificationsComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('code-clairvoyance-ui');
  constructor(
    private readonly cookieState: CookieStateService,
    private readonly processingState: ProcessingStateService,
    private readonly sessionService: SessionService
  ) { }
  private readonly uiCookieName = 'cc_ui';

  theme: Theme = 'dark';

  ngOnInit(): void {
    this.restoreUiFromCookie();
  }

  get isLoggedIn(): boolean {
    return this.sessionService.isAuthenticated();
  }

  get signedInDisplayName(): string | null {
    return this.sessionService.getDisplayName();
  }

  get isProcessing(): boolean {
    return this.processingState.isProcessing();
  }

  onThemeChange(theme: Theme): void {
    this.theme = theme;
    this.persistUiToCookie();
  }

  private restoreUiFromCookie(): void {
    const parsed = this.cookieState.readJson<Partial<{
      theme: Theme;
    }>>(this.uiCookieName);
    if (!parsed) return;

    if (parsed.theme === 'dark' || parsed.theme === 'light') this.theme = parsed.theme;
  }

  private persistUiToCookie(): void {
    this.cookieState.writeJson(this.uiCookieName, {
      theme: this.theme,
    }, 365);
  }
}
